module.exports = __webpack_public_path__ + "img/中国海关体育协会@3x.7f7ca3b3.png";